import React from "react";
import { FormattedMessage } from "react-intl";
import Phone from "../../../components/tables/Phone";
import Address from "../../../components/tables/Address";
import FullName from "../../../components/tables/FullName";
import IdOrPassport from "../../../components/tables/IdOrPassport";
import Age from "../../../components/tables/Age";
import AvatarComponent from "../../../components/tables/AvatarComponent";
import Gender from "../../../components/tables/Gender";
import EmployeeStatus from "../../../components/tables/EmployeeStatus";
import EmployeeTypes from "../../../components/tables/EmployeeTypes";
import {
  DownOutlined,
  PlusOutlined,
  ScheduleOutlined,
} from "@ant-design/icons";
import { Button, Dropdown } from "antd";
import { SearchOutlined } from "@ant-design/icons";

const getColumns = (
  isAdmin,
  intl,
  handleAdminMenuClick,
  handleMenuClick,
  userBranches,
  EmployeeBranches,
  isAllowedFeature
) => {
  const tableItems = [
    {
      title: "avatar_url",
      render: AvatarComponent,
      width: "80px",
    },
    {
      title: "fullname",
      sortIndex: "surename",
      sorter: true,
      render: FullName,
      ellipsis: true,
    },
    {
      title: "status",
      render: EmployeeStatus,
      ellipsis: true,
      width: "95px",
      filters: [
        { text: <FormattedMessage id="app.forms.active" />, value: 1 },
        {
          text: <FormattedMessage id="app.forms.not_active" />,
          value: 2,
        },
        { text: <FormattedMessage id="app.forms.candidate" />, value: 3 },
      ],
    },
    {
      title: "employee_type_id",
      render: EmployeeTypes,
      responsive: ["md"],
      width: "140px",
      filters: [
        {
          text: (
            <FormattedMessage id="app.dataSelect.employee_type_id.israel_citizen" />
          ),
          value: 1,
        },
        {
          text: (
            <FormattedMessage id="app.dataSelect.employee_type_id.foreign_citizen" />
          ),
          value: 2,
        },
        {
          text: (
            <FormattedMessage id="app.dataSelect.employee_type_id.territories_citizen" />
          ),
          value: 3,
        },
      ],
    },
    {
      title: "idOrPassport",
      responsive: ["xxl"],
      render: IdOrPassport,
      ellipsis: true,
      width: "120px",
    },

    {
      title: "accounting_info.number",
      responsive: ["xxl"],
      ellipsis: true,
    },
    {
      title: "contact_info.mobile_number",
      render: Phone,
      width: "140px",
      ellipsis: true,
    },
    {
      title: "age",
      responsive: ["xl"],
      render: Age,
      columnProps: { field: "birthday" },
      width: "70px",
      sortIndex: "birthday",
      sorter: true,
    },
    {
      title: "gender_id",
      responsive: ["xl"],
      render: Gender,
      width: "100px",
      filters: [
        {
          text: <FormattedMessage id="app.dataSelect.gender_id.male" />,
          value: 1,
        },
        {
          text: <FormattedMessage id="app.dataSelect.gender_id.female" />,
          value: 2,
        },
      ],
    },
    {
      title: "address",
      responsive: ["lg"],
      ellipsis: true,
      render: Address,
    },
    {
      title: "actions",
      responsive: ["md"],
      width: "120px",
      render: ({ record }) => (
        <div style={{ display: "flex" }}>
          {isAdmin ? (
            <Dropdown
              trigger={["click"]}
              menu={{
                items: [
                  {
                    label: intl.formatMessage({
                      id: "app.employees.showBrief",
                    }),
                    key: "1",
                    icon: <SearchOutlined />,
                  },

                  {
                    label: intl.formatMessage({
                      id: "app.employees.assignEmployee",
                    }),
                    key: "2",
                    icon: <PlusOutlined />,
                  },
                  {
                    label: intl.formatMessage({
                      id: "app.employees.approveScheduling",
                    }),
                    key: "3",
                    icon: <ScheduleOutlined />,
                  },

                  {
                    label: intl.formatMessage({
                      id: "app.employees.showSchedulingHistory",
                    }),
                    key: "4",
                    icon: <ScheduleOutlined />,
                  },

                  {
                    label: intl.formatMessage({
                      id: "app.employees.showReplacements",
                    }),
                    key: "5",
                    icon: <ScheduleOutlined />,
                  },

                  {
                    label: intl.formatMessage({
                      id: "app.employees.printDiaries",
                    }),
                    key: "6",
                    icon: <ScheduleOutlined />,
                  },
                  ...[
                    isAllowedFeature("forms") && {
                      label: intl.formatMessage({
                        id: "app.employees.print_forms",
                      }),
                      key: "7",
                      icon: <ScheduleOutlined />,
                    },
                  ],
                ],
                onClick: (e) => handleAdminMenuClick(e, record),
              }}
            >
              <Button type="link">
                {intl.formatMessage({
                  id: "app.employees.options",
                })}
                <DownOutlined />
              </Button>
            </Dropdown>
          ) : (
            <Dropdown
              trigger={["click"]}
              menu={{
                items: [
                  {
                    label: intl.formatMessage({
                      id: "app.employees.showBrief",
                    }),
                    key: "1",
                    icon: <SearchOutlined />,
                  },

                  {
                    label: intl.formatMessage({
                      id: "app.employees.approveScheduling",
                    }),
                    key: "2",
                    icon: <ScheduleOutlined />,
                  },

                  {
                    label: intl.formatMessage({
                      id: "app.employees.showSchedulingHistory",
                    }),
                    key: "3",
                    icon: <ScheduleOutlined />,
                  },

                  {
                    label: intl.formatMessage({
                      id: "app.employees.showReplacements",
                    }),
                    key: "4",
                    icon: <ScheduleOutlined />,
                  },

                  {
                    label: intl.formatMessage({
                      id: "app.employees.printDiaries",
                    }),
                    key: "5",
                    icon: <ScheduleOutlined />,
                  },
                  ...[
                    isAllowedFeature("forms") && {
                      label: intl.formatMessage({
                        id: "app.employees.print_forms",
                      }),
                      key: "6",
                      icon: <ScheduleOutlined />,
                    },
                  ],
                ],
                onClick: (e) => handleMenuClick(e, record),
              }}
            >
              <Button type="link">
                {intl.formatMessage({
                  id: "app.employees.options",
                })}
                <DownOutlined />
              </Button>
            </Dropdown>
          )}
        </div>
      ),
    },
  ];

  if (isAdmin) {
    tableItems.splice(2, 0, {
      title: "branches",
      render: EmployeeBranches,
      width: "120px",
      responsive: ["lg"],
      filters: userBranches.map((i) => ({ text: i.name, value: i.id })),
    });
  }

  return tableItems;
};

export { getColumns };
